<template>
    <div>
        <toggle-button :value="value.type"
                       :color="colorToggle"
                       :sync="true"
                       :labels="labelToggle"
                       :width="150"
                       @change="changeType"/>
        <div class="input-group">
            <span class="input-group-addon"><i class="fa" :class="isCalculating === true ? 'fa-spinner' : checkWeb"></i> {{ url.protocol }}</span>
            <input v-model="value.name"
                   type="text"
                   name="name"
                   class="form-control"
                   required
                   :disabled="isCalculating === true"
                   v-on:keyup="searchQuery">
            <span v-show="value.type === true" class="input-group-addon">{{ url.hostname }} </span>
        </div>
        <div class="help-block invalid-feedback"
             v-if="errors.has('url_ident')"
             v-for="error in errors.errors.url_ident"
             style="display: block;margin-bottom: 5px;" v-html="error"></div>
        <ul v-if="value.type === false">
            <li>{{ $t('help_addresses_our_ns_servers') }}</li>
            <li>{{ ns1 }}</li>
            <li>{{ ns2 }}</li>
        </ul>
    </div>
</template>

<script>
    import _ from 'lodash';
    import { mapGetters } from 'vuex';
    import Request from '../../services/Requests.js';
    import ToggleButton from 'vue-js-toggle-button';

    export default {
        props: {

            /**
             * @type Object
             */
            value: {
                type: Object,
                default: function () {
                    return {
                        name: '',
                        type: true
                    };
                }
            },

            errors: {
                type: Object,
                default: () => {
                    return {
                        url_ident: []
                    }
                }
            }
        },

        components: {
            //
        },

        data() {
            return {
                url: {
                    protocol: location.protocol + '//',
                    hostname: '.' + location.hostname
                },
                ns1: 'ns1.'+location.hostname,
                ns2: 'ns2.'+location.hostname,
                searchQueryIsDirty: false,
                isCalculating: false,
                error: undefined,
                labelToggle: {
                    checked: 'Локальний',
                    unchecked: 'Зовнішній адрес'
                },
                colorToggle: {
                    checked: '#007bff',
                    unchecked: '#007bff'
                }
            }
        },

        computed: {
            ...mapGetters({
                checkWebByName: 'getGymByName'
            }),

            checkWeb() {
                if (this.checkWebByName === 'fa-times') {
                    this.error = 'Така назва домену вже існує!';
                    this.error;
                }
                return this.checkWebByName;
            }
        },

        methods: {
            changeType(data) {
                this.$emit('change-type', data.value);
            },

            searchQuery: function () {
                this.searchQueryIsDirty = true;
                this.expensiveOperation();
            },

            expensiveOperation: _.debounce(function () {
                if(this.value.type === 'local') {
                    if (/^[0-9a-z]{0}[-0-9a-z]{1}[0-9a-z]{1,2}([-0-9a-z]{0,1})?([0-9a-z]{0,2})?([-0-9a-z]{0,1})?([0-9a-z]{0,2})?([-]{0,1})?([a-z]{0,10})?$/.test(this.value.name)) {
                        this.isCalculating = true;
                        const data = {url_ident: this.value.name};
                        this.$store.dispatch('getGymByName', data)
                            .finally(() => {
                                this.error = undefined;
                                this.isCalculating = false;
                            });
                    } else {
                        this.error = 'Введено неприпустимі символи!';
                    }
                } else {
                    if (/^[a-zA-Z0-9][a-zA-Z0-9-]{1,61}[a-zA-Z0-9](?:\.[a-zA-Z]{2,})+$/.test(this.value.name)) {
                        this.isCalculating = true;
                        const data = {url_ident: this.value.name};
                        this.$store.dispatch('getGymByName', data)
                            .finally(() => {
                                this.error = undefined;
                                this.isCalculating = false;
                            });
                    } else {
                        this.error = 'Введено неприпустимі символи!';
                    }
                }
            }, 1000)
        }
    }
</script>

<style scoped>
    label {
        margin-left: 15px;
        margin-right: 15px;
    }
    label input {
        margin-right: 5px;
    }
    ul {
        margin-top: 0.5rem;
        margin-bottom: 0;
    }
    ul li {
        display: block;
        font-size: 14px;
    }
    .red {
        color: #dc3545;
        margin: 0;
    }
    .green {
        color: green;
    }
</style>


// WEBPACK FOOTER //
// resources/assets/js/components/common/ss_hostname.vue